<template>
  <form
    class="stroke-group-search my-4"
    :class="{ 'is-loading': isLoading }"
    ref="strokeForm"
    @submit.prevent="handleSubmit"
    novalidate
  >
    <div class="location-search__fields">
      <div class="form-group">
        <label :for="zipcodeId">{{ translations.zipCode }}</label>
        <input
          :id="zipcodeId"
          name="zipcode"
          type="text"
          ref="input1"
          class="form-control"
          pattern="^\d{5}(?:[-\s]\d{4})?$"
          v-model="zipcode"
          :placeholder="translations.zipCodePlaceholder"
        >
      </div>

      <span class="ml-5 d-xs-none">&nbsp;</span>

      <div class="form-group">
        <label :for="radiusId">{{ translations.radius }}</label>

        <select class="custom-select btn--select" :id="radiusId" name="radius" v-model="rad">
          <option value>Select radius</option>
          <option v-for="rad in radius" :value="rad.code" :key="rad.code">{{ rad.title }}</option>
        </select>
      </div>
    </div>

    <button
      class="location-search__search btn btn-tertiary btn-round"
      :disabled="!validInput"
      ref="submit"
      type="submit"
    >{{ translations.search }}</button>
  </form>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      zipcode: "",
      rad: "",
      isLoading: false,
      zipcodeId: null,
      radiusId: null
    };
  },
  mounted() {
    this.zipcodeId = "zipcode_" + this._uid;
    this.radiusId = "radius_" + this._uid;

    const data = localStorage.getItem('_aha.last-group-finder');

    if(data) {
        let psoptions = JSON.parse(data);

        this.zipcode = psoptions.searchText;
        this.rad = psoptions.radius;
    }
    // this.$refs.input1.focus();
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    onSubmit: {
      type: Function
    },
    translations: {
      type: Object,
      required: true
    },
    endpoint: {
      type: String,
      required: true
    },
    radius: {
      type: Array
    }
  },
  computed: {
    validInput() {
      return this.rad !== "" && this.zipcode !== "";
    }
  },
  watch: {
    isVisible: function(val) {
      if (val) {
        this.focusRef(this.$refs.input1);
      }
    }
  },

  methods: {
    handleSubmit() {
      localStorage.removeItem('_aha.last-group-finder');
      this.isLoading = true;
      this.$parent.$data.isLoading = true;

      axios
        .post(this.$props.endpoint, {
          zipcode: this.zipcode,
          radius: this.rad
        })
        .then(response => {
          this.isLoading = false;
          // Pass the data back to the parent component
          this.onSubmit({
            searchText: this.zipcode,
            locations: response.data,
            radius: this.rad,
            isLoading: false
          });

          this.rad = "";
          this.zipcode = "";
        })
        .catch(error => {
          this.isLoading = false;
          this.onSubmit({
            invalidZipCode: true,
            isLoading: false
          });
        });
    },
    focusRef(ref) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          (typeof ref.$el !== "undefined" ? ref.$el : ref).focus();
        });
      });
    },
    resetForm() {
      this.$refs.strokeForm.reset();
      this.$refs.input1.focus();
      localStorage.removeItem('_aha.last-group-finder');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/app/components/stroke-group-selector-form.vue